import clsx from 'clsx';
import { Flex, Paper, Stack, Text } from '@mantine/core';
import { MChatMessage } from '@/src/modules/chat/models/chat-message';
import { formatDisplayShortTime } from '@/src/shared/utils/datetime';
import { ChatAttachmentGroup } from './chat-attachment-group';
import MessagePaperTriangle from './chat-message-paper-triangle';

interface IChatMessagePaperProps {
  size?: 'sm' | 'md';
  message: MChatMessage;
  fromMe?: boolean;
}

export default function ChatMessagePaper({
  size = 'md',
  message,
  fromMe = false,
}: IChatMessagePaperProps) {
  const isNormalSize = size === 'md';

  return (
    <Flex gap={0} direction={fromMe ? 'row-reverse' : 'row'}>
      <MessagePaperTriangle fromMe={fromMe} />
      <Paper
        py="0.5rem"
        px="sm"
        bg={fromMe ? 'brand.1' : undefined}
        classNames={{
          root: clsx(
            'whitespace-pre-line',
            fromMe ? 'rounded-tr-none!' : 'rounded-tl-none!'
          ),
        }}
        miw={isNormalSize ? '6rem' : '5rem'}
        shadow="none"
      >
        <Stack gap={0}>
          <Stack gap={message.hasAttachments ? 'xs' : 0}>
            {message.props.content && (
              <Text
                fz={isNormalSize ? 'sm' : '0.75rem'}
                className="break-all hyphens-auto"
                c={fromMe ? 'gray.1' : 'black'}
              >
                {message.props.content}
              </Text>
            )}

            {message.hasAttachments && (
              <ChatAttachmentGroup
                size={size}
                attachments={message.props.attachments!}
                fromMe={fromMe}
              />
            )}
          </Stack>

          <Text
            fz={isNormalSize ? 'xs' : '0.6rem'}
            ta={fromMe ? 'right' : 'left'}
            mt="0.4rem"
            c={fromMe ? 'gray.3' : 'dimmed'}
          >
            {formatDisplayShortTime(message.props.sentAt)}
          </Text>
        </Stack>
      </Paper>
    </Flex>
  );
}
